/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderTriggers = 'GoBackToPrevious' | 'CancelTender' | 'TenderCompleted' | 'CorrectTender' | 'RequestApproval' | 'SpecificationCompleted' | 'Approved' | 'Disapproved' | 'CollectiveSourcingCompleted' | 'Published' | 'SkipSimapPublication' | 'OfferingCompleted' | 'ReviseOfferOpening' | 'RatingCompleted' | 'AuctionCompleted' | 'DecisionCompleted' | 'NoDecision' | 'CommunicationAwardCompleted' | 'RecallDecision' | 'ProjectCompleted' | 'Recall';

export const TenderTriggers = {
    GoBackToPrevious: 'GoBackToPrevious' as TenderTriggers,
    CancelTender: 'CancelTender' as TenderTriggers,
    TenderCompleted: 'TenderCompleted' as TenderTriggers,
    CorrectTender: 'CorrectTender' as TenderTriggers,
    RequestApproval: 'RequestApproval' as TenderTriggers,
    SpecificationCompleted: 'SpecificationCompleted' as TenderTriggers,
    Approved: 'Approved' as TenderTriggers,
    Disapproved: 'Disapproved' as TenderTriggers,
    CollectiveSourcingCompleted: 'CollectiveSourcingCompleted' as TenderTriggers,
    Published: 'Published' as TenderTriggers,
    SkipSimapPublication: 'SkipSimapPublication' as TenderTriggers,
    OfferingCompleted: 'OfferingCompleted' as TenderTriggers,
    ReviseOfferOpening: 'ReviseOfferOpening' as TenderTriggers,
    RatingCompleted: 'RatingCompleted' as TenderTriggers,
    AuctionCompleted: 'AuctionCompleted' as TenderTriggers,
    DecisionCompleted: 'DecisionCompleted' as TenderTriggers,
    NoDecision: 'NoDecision' as TenderTriggers,
    CommunicationAwardCompleted: 'CommunicationAwardCompleted' as TenderTriggers,
    RecallDecision: 'RecallDecision' as TenderTriggers,
    ProjectCompleted: 'ProjectCompleted' as TenderTriggers,
    Recall: 'Recall' as TenderTriggers
};

